import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SEOHeadProps {
  title: string;
  description: string;
  keywords?: string[];
  image?: string;
  url?: string;
  type?: 'website' | 'article' | 'profile' | 'music.song' | 'music.album';
  structuredData?: object;
  noIndex?: boolean;
}

export function SEOHead({
  title,
  description,
  keywords = [],
  image = 'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=1200&h=630&fit=crop',
  url,
  type = 'website',
  structuredData,
  noIndex = false,
}: SEOHeadProps) {
  const fullTitle = title.includes('jamnation') ? title : `jamnation - ${title}`;
  const currentUrl = url || (typeof window !== 'undefined' ? window.location.href : '');
  const keywordsArray = Array.isArray(keywords) ? keywords : [];

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywordsArray.length > 0 && <meta name="keywords" content={keywordsArray.join(', ')} />}
      
      {/* Robots */}
      {noIndex && <meta name="robots" content="noindex, nofollow" />}
      
      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={currentUrl} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="jamnation" />
      <meta property="og:locale" content="de_CH" />
      
      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      
      {/* Canonical URL */}
      <link rel="canonical" href={currentUrl} />
      
      {/* Structured Data */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
}